import * as React from 'react';
import { BarChart, CartesianGrid, XAxis, Tooltip, YAxis, Bar } from 'recharts';
import { ShipmentSummary, Branch } from '../Models/Report';
import Loading from './Loading';
import './BarSummary.scss';
import { formatAmount } from '../Utils/NumberFormat';
import Balloon from './Balloon';
import moment from "moment";
import { capitalize } from '../Utils/StrUtil';


export interface IBarSummaryProps {
	data: ShipmentSummary;
	branch: Branch;
}

export const LabelBar = (props: any) => {
	const { x, y, fill, value } = props;
	return <text
		x={x}
		y={y}
		dx={10}
		dy={-4}
		fontSize='0.6rem'
		fontFamily='lato'
		fill={fill}
		textAnchor="middle">{formatAmount(value, true)}
	</text>
}

export const LabelLegend = (props: any) => {
	const { x, y, fill, value } = props;
	return <text
		x={x}
		y={y}
		dx={10}
		dy={-4}
		fontSize='0.6rem'
		fontFamily='lato'
		fill={fill}
		textAnchor="middle">{formatAmount(value, true)}
	</text>
}

export const BarSummary = (props: IBarSummaryProps) => {
	React.useEffect(() => {
		moment.locale("es");
	});
	if (!props.data || !props.data.details) {
		return <Loading />;
	}
	const data = props.data.details
		.sort((a, b) => a.date.unix() - b.date.unix())
		.map(d => ({ name: d.date.locale('es').format('MMM YYYY'), 'Consolidada': d.consolidate, 'Break Bulk': d.breakBulk }))
	return <div className="BarSummary">
		<h1>Resumen Anual Faena <span>{capitalize(props.branch.name)}</span></h1>
		<p>Gráfico comparativo por estado</p>
		<div className="BarSummary-Chart-Content">
			<div className="BarSummary-Chart">
				<BarChart
					width={900}
					height={300}
					data={data}
					margin={{
						top: 5, right: 30, left: 20, bottom: 5,
					}}
				>
					<CartesianGrid vertical={false} />
					<XAxis dataKey="name" />
					<YAxis />
					<Bar label={<LabelBar />} dataKey="Consolidada" fill="#0B60B9" />
					<Bar label={<LabelBar />} dataKey="Break Bulk" fill="#F7A72E" />
				</BarChart>

				<BarChart
					className="Medium"
					width={600}
					height={300}
					data={data.slice(0, Math.trunc(data.length / 2))}
					margin={{
						top: 5, right: 30, left: 20, bottom: 5,
					}}
				>
					<CartesianGrid vertical={false} />
					<XAxis dataKey="name" />
					<YAxis />
					<Bar label={<LabelBar />} dataKey="Consolidada" fill="#0B60B9" />
					<Bar label={<LabelBar />} dataKey="Break Bulk" fill="#F7A72E" />
				</BarChart>

				<BarChart
					className="Medium"
					width={600}
					height={300}
					data={data.slice((data.length / 2))}
					margin={{
						top: 5, right: 30, left: 20, bottom: 5,
					}}
				>
					<CartesianGrid vertical={false} />
					<XAxis dataKey="name" />
					<YAxis />
					<Bar label={<LabelBar />} dataKey="Consolidada" fill="#0B60B9" />
					<Bar label={<LabelBar />} dataKey="Break Bulk" fill="#F7A72E" />
				</BarChart>
				<div className="BarSummary-Chart-Legend">
					<div className="BarSummary-Chart-Legend-Item">
						<Balloon color="#0B60B9" size={13} />
						<p>Consolidada</p>
					</div>
					<div className="BarSummary-Chart-Legend-Item">
						<Balloon color="#F7A72E" size={13} />
						<p>Break Bulk</p>
					</div>
				</div>
			</div>
		</div>
	</div>
}

export default BarSummary;
